import { cx } from "cva";
import { BuildHtml } from "~/components/BuildHtml";
import { Body, Headline, Link } from "~/ui-library";
import { ClampedText } from "~/ui-library/components/ClampedText";

export type ArticleHeaderProps = {
  kicker: string;
  kickerSecondaryText: string | null;
  kickerHref?: string | null;
  headline: string;
  subhead: string;
  chartDescription?: string;
  className?: string;
};

export function ArticleHeader({
  kicker,
  kickerSecondaryText,
  kickerHref,
  headline,
  subhead,
  chartDescription,
  className,
}: ArticleHeaderProps) {
  const renderedKicker = (
    <div className="mb-s flex items-center gap-xs pt-l xl:pt-xl">
      {kickerHref ? (
        <Headline level={6} blockCase className="text-primary">
          <Link href={kickerHref}>{kicker}</Link>
        </Headline>
      ) : (
        <Headline level={6} blockCase className="text-primary">
          {kicker}
        </Headline>
      )}

      {kickerSecondaryText ? (
        <>
          <Body bold className="text-gray-400">
            •
          </Body>
          <Body bold className="text-gray-700">
            {kickerSecondaryText}
          </Body>
        </>
      ) : null}
    </div>
  );
  return (
    <div className={cx(className, "max-w-[800px] print:max-w-full")}>
      {renderedKicker}
      <Headline
        as="h1"
        level={2}
        mdLevel={0}
        className="mb-s print:text-headline0"
      >
        {headline}
      </Headline>

      <Body size="large" className="mb-l print:text-body-large">
        {subhead}
      </Body>
      {chartDescription?.length ? (
        <ClampedText className="mt-s" lineCount={2}>
          <BuildHtml allowStyles html={chartDescription} />
        </ClampedText>
      ) : null}
    </div>
  );
}
